import { render, staticRenderFns } from "./ViewChallenge.vue?vue&type=template&id=2267662a&scoped=true&"
import script from "./ViewChallenge.vue?vue&type=script&lang=js&"
export * from "./ViewChallenge.vue?vue&type=script&lang=js&"
import style0 from "./ViewChallenge.vue?vue&type=style&index=0&id=2267662a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2267662a",
  null
  
)

export default component.exports